// Gateway 套件（共用信封／登入階段）訊息型別查表 helper。
// 對應後端權威 proto 的 package `Gateway`（gateway_cmd / gateway_login / gateway_gameinfo /
// gateway_getbalance / gateway_deviceinfo）。
import type * as protobuf from 'protobufjs'
import { lookupType } from './protoRoot'

/** 取得 Gateway 套件下的訊息型別，如 `ClientSpinCmd`、`LoginCmd`、`GetGameInfoCmd`、`DeviceInfo`。 */
export function gatewayType(name: string): protobuf.Type {
  return lookupType(`Gateway.${name}`)
}
